import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { TrashIcon } from "../../../ui/icons/trash"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { PopupForm } from "../../../ui/organisms/popupForm"
import { BusinessRegisterRequestMotivationOptions, BusinessRegisterTypologyRequestOptions, formatterDate, optionsFormatter } from "../../../utils"
import { BusinessRegisterDTO } from "./dataService/dto"
import { BusinessRegisterDelete, GetAllBusinessRegisters, resetBusinessRegisterDeleteStatus, setAddedRegisterCreationBusinessRegisterId, setAddedRegisterCreationCustomerId, setAddedRegisterCreationOfficerId, setAddedRegisterCreationTypeRegisterId, setBusinessRegisterIdToUpdate, setBusinessRegisterUpdateNote, setBusinessRegisterUpdateReleaseDate, setBusinessRegisterUpdateReleaseProtocolId, setBusinessRegisterUpdateReleaseRegister, setBusinessRegisterUpdateRequestProtocolId, setBusinessRegisterUpdateRequestReason, setBusinessRegisterUpdateRequestType, setGetAllAddedRegistersFiltersBusinessRegisterId } from "./slice"

export function RegistriAziendaliList() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const userState = useAppSelector(state => state.users)
    const registerState = useAppSelector(state => state.register)
    const [regToDelete, setRegToDelete] = useState<string | null>(null)
    const [showAlert, setShowAlert] = useState<boolean>(false)

    const onEditHandler = (data: BusinessRegisterDTO) => {
        dispatch(setBusinessRegisterIdToUpdate(data.id))
        dispatch(setBusinessRegisterUpdateRequestProtocolId(data.requestProtocolId))
        dispatch(setBusinessRegisterUpdateRequestType(data.requestType))
        dispatch(setBusinessRegisterUpdateRequestReason(data.requestReason))
        dispatch(setBusinessRegisterUpdateReleaseRegister(data.releaseRegister))
        dispatch(setBusinessRegisterUpdateReleaseProtocolId(data.releaseProtocolId))
        dispatch(setBusinessRegisterUpdateReleaseDate(data.releaseDate))
        dispatch(setBusinessRegisterUpdateNote(data.note))
        dispatch(setGetAllAddedRegistersFiltersBusinessRegisterId(data.id))
        dispatch(setAddedRegisterCreationBusinessRegisterId(data.id))
        dispatch(setAddedRegisterCreationOfficerId(userState.findMeResponse.id))
        dispatch(setAddedRegisterCreationCustomerId(sessionState.selected.customerId))
        dispatch(setAddedRegisterCreationTypeRegisterId(""))
        navigate('/editRegistroAziendale')
    }

    useEffect(() => {
        dispatch(GetAllBusinessRegisters({ itemsPerPage: 0, page: 0, customerId: sessionState.selected.customerId! }))
    }, [])

    useEffect(() => {

        if (registerState.businessRegisterDeleteStatus === 'successfully') {
            dispatch(resetBusinessRegisterDeleteStatus())
            dispatch(GetAllBusinessRegisters({ itemsPerPage: 0, page: 0, customerId: sessionState.selected.customerId! }))
        }
    }, [registerState.businessRegisterDeleteStatus])

    return (
        <div className="p-6">
            <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm ">
                <table id="users-table" className="w-full border-collapse text-sm">
                    <thead>
                        <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Data Richiesta</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Motivo Richiesta</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Richiesta</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipo Richiesta</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data rilascio</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Rilascio</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Note</th>
                            <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[80px]"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {(registerState.getAllBusinessRegistersResponse?.data ?? []).length === 0 ? (
                            <tr>
                                <td colSpan={8} className="px-3 py-3 text-center text-neutral-500 bg-white">
                                    Nessun registro trovato
                                </td>
                            </tr>
                        ) : (
                            (registerState.getAllBusinessRegistersResponse?.data ?? []).map((regAz, index) =>
                                <tr
                                    key={index}
                                    className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                >
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(regAz.requestDate)}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{optionsFormatter(regAz.requestReason, BusinessRegisterRequestMotivationOptions)}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{regAz.requestProtocolInfo}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{optionsFormatter(regAz.requestType, BusinessRegisterTypologyRequestOptions)}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(regAz.releaseDate)}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{regAz.releaseProtocolInfo}</td>
                                    <td className="px-3 py-2 text-neutral-700">{regAz.note || '-'}</td>
                                    <td className="px-3 py-2">
                                        <div className="flex gap-2 justify-center">
                                            <button className="cursor-pointer" onClick={() => onEditHandler(regAz)}>
                                                <EditIcon color="orange" size={20} />
                                            </button>
                                            <button className="cursor-pointer" onClick={() => {
                                                setRegToDelete(regAz.id)
                                                setShowAlert(true)
                                            }}>
                                                <TrashIcon color="red" size={20} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
            </div>
            {
                (showAlert && regToDelete) && (
                    <PopupForm title="Conferma operazione" close={() => setShowAlert(false)}>
                        <div className="p-6 bg-white flex flex-col gap-6">
                            <p className="text-left text-md font-medium text-neutral-700">
                                Sei sicuro di voler eliminare il registro?
                            </p>
                            <div className="flex justify-end gap-2 pt-2 border-t border-neutral-200">
                                <ButtonComponent
                                    variant="outline"
                                    color="blue"
                                    iconPosition="off"
                                    label="Annulla"
                                    size="md"
                                    onClick={() => setShowAlert(false)}
                                />
                                <ButtonComponent
                                    variant="solid"
                                    color="red"
                                    iconPosition="off"
                                    label="Elimina"
                                    size="md"
                                    onClick={() => {
                                        dispatch(BusinessRegisterDelete(regToDelete))
                                        setShowAlert(false)
                                    }}
                                />
                            </div>
                        </div>
                    </PopupForm>
                )
            }
        </div>
    )
}